import { render, staticRenderFns } from "./RelationshipClassification.vue?vue&type=template&id=723f3060"
import script from "./RelationshipClassification.vue?vue&type=script&lang=ts"
export * from "./RelationshipClassification.vue?vue&type=script&lang=ts"
import style0 from "./RelationshipClassification.vue?vue&type=style&index=0&id=723f3060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports